<div mat-dialog-content>
  <div class="text-center">
    <div class="i-circle danger">
      <i class="fas fa-times"></i>
    </div>
    <h4 class="color-default" innerHTML="{{ message | translate}}"></h4>
    <p></p>
  </div>
</div>
<div mat-dialog-actions>
  <div class="full-width text-right">
    <button type="button" class="btn btn-default" title="{{'BUTTON.CANCEL' | translate}}" (click)="dialogRef.close(false)">
      <i class="fas fa-ban"></i>&nbsp;{{'BUTTON.CANCEL' | translate}}
    </button>
    <button type="button" class="btn btn-danger" title="{{'BUTTON.CONFIRM' | translate}}" (click)="dialogRef.close(true)">
      <i class="fas fa-check"></i>&nbsp;{{'BUTTON.CONFIRM' | translate}}
    </button>
  </div>
</div>